import React from 'react';
import { Icon } from 'ui';
import OptionsMenu from '../../editor/collaboration/ThreadOptions'; // TODO refactor this

const renderOptions = options =>
  options.map(({ onClick, label, icon }) => ({
    onClick,
    children: (
      <span>
        <Icon name={icon} className="mr-8 c-brand-gray-light" />
        {label}
      </span>
    ),
  }));

const Item = ({ id, name, children, editing, options }) => (
  <div className="fz-base c-brand-gray-darker mb-4 p-4 ai-c d-f jc-sb bdrs-base h-bc-gray-lightest">
    {children || name}
    {editing && options && <OptionsMenu options={renderOptions(options)} />}
  </div>
);

export default Item;
